import { css } from "@emotion/react"
import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import Fade from "react-reveal/Fade"
import CheckLinkDomain from "../../utility/current_domain"
import CarouselComponent from "../carousel-component"
import SVGIcon from "../SVGIcon"
import "./FeatureCards.scss"

const FeatureCards = props => {
  const {
    title,
    description,
    image,
    color,
    linkName,
    link,
    cardsPerRow,
    showBgColorImgOnHover,
    version,
    noCarousal,
  } = props
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.19,
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 1.2,
    },
    mobile: {
      breakpoint: { max: 767, min: 500 },
      items: 1.2,
    },
    mobile1: {
      breakpoint: { max: 500, min: 0 },
      items: 1,
    },
  }
  const [screenWidth, setScreenWidth] = useState(0)
  useEffect(() => {
    setScreenWidth(window.innerWidth)
  }, [])
  let delayCount = 0

  const InnerComponent = ({ idx }) => {
    return (
      <div className="d-flex flex-column justify-content-between padding-bar h-100">
        <div>
          {image?.[idx]?.url ? (
            <div className="logo-wrap mb40">
              <img src={image?.[idx]?.url} alt="logo" className="w-100" />
            </div>
          ) : null}

          <p className="p24 font-zodiak fw-800 text-deep-purple">
            {title?.[idx]}
          </p>
          <p className="p16 mb40 text-deep-purple">{description?.[idx]}</p>
        </div>
        {linkName?.[idx] ? (
          <Link
            to={link?.[idx]}
            target={CheckLinkDomain(link?.[idx]) ? "_self" : "_blank"}
            className="link"
          >
            {linkName?.[idx]}
            <SVGIcon name="hypertext-arrow-right" className="arrow-right" />
          </Link>
        ) : (
          <></>
        )}
      </div>
    )
  }

  return (
    <div className="feature-cards">
      <div className={`${noCarousal ? "dspnone" : "d-mob"}`}>
        <CarouselComponent
          swipeable
          responsive={responsive}
          customButtonNew
          status
          items={screenWidth >= 992 ? 2.19 : 1}
          paginationDecrement={screenWidth >= 992 ? true : false}
          arrowClassName="btn-secondary-new"
        >
          {title?.map((item, idx) => {
            return (
              <div
                className={`individual-card h-100 d-flex flex-column justify-content-between ${
                  version ? version : ""
                } ${
                  cardsPerRow
                    ? `cards-count-${cardsPerRow}`
                    : `cards-count-${title?.length}`
                } ${color?.length ? "color" : "normal"}`}
                css={css`
                  background: ${color?.[idx] ?? "none"};
                `}
              >
                {version ? (
                  <div className="padding-bar">
                    <h3 className="font-zodiak fw-800 text mb24 text-deep-purple">
                      {item}
                    </h3>
                    <p className="p24 subtext text-deep-purple">
                      {description?.[idx]}
                    </p>
                  </div>
                ) : (
                  <>
                    {linkName?.[idx] ? (
                      <Link
                        to={link?.[idx]}
                        target={
                          CheckLinkDomain(link?.[idx]) ? "_self" : "_blank"
                        }
                        className="h-100"
                      >
                        <InnerComponent idx={idx} />
                      </Link>
                    ) : (
                      <InnerComponent idx={idx} />
                    )}
                  </>
                )}
              </div>
            )
          })}
        </CarouselComponent>
      </div>
      <div
        className={`${
          noCarousal ? "" : "d-dsk"
        } cards-container d-flex gap-24 flex-wrap justify-content-center`}
      >
        {title?.map((item, idx) => {
          if (delayCount > 5) {
            delayCount = 0
          }
          return (
            <Fade
              bottom
              delay={(delayCount + 1) * 130}
              duration="800"
              distance={"20px"}
            >
              <span className="dspnone">{delayCount++}</span>

              <div
                className={`individual-card position-relative h-100 d-flex flex-column justify-content-between ${
                  version ? version : ""
                } ${
                  cardsPerRow
                    ? `cards-count-${cardsPerRow}`
                    : `cards-count-${title?.length}`
                } ${color?.length ? "color" : "normal"} ${
                  showBgColorImgOnHover ? "show-bg-color-on-hover" : ""
                }`}
                css={css`
                  background: ${color?.[idx] ?? "none"};
                `}
              >
                {version ? (
                  <div className="padding-bar">
                    <h3 className="font-zodiak fw-800 text mb80 text-deep-purple">
                      {item}
                    </h3>
                    <p className="p24 fw-600 subtext text-deep-purple">
                      {description?.[idx]}
                    </p>
                  </div>
                ) : (
                  <>
                    {link?.[idx] ? (
                      <Link
                        to={link?.[idx]}
                        target={
                          CheckLinkDomain(link?.[idx]) ? "_self" : "_blank"
                        }
                        className="h-100"
                      >
                        <InnerComponent idx={idx} />
                      </Link>
                    ) : (
                      <InnerComponent idx={idx} />
                    )}
                  </>
                )}
                <div className="position-absolute bg-color-card" />
              </div>
            </Fade>
          )
        })}
      </div>
    </div>
  )
}

export default FeatureCards
